export default __webpack_public_path__ + "static/media/template_business-man__0025_2---richard-yong.303babd3.png";